import React from 'react';
import { Box, Cell, Layout, Text } from '@wix/design-system';
import { Gift } from '@wix/wix-ui-icons-common/lazy';
import { getPremiumEssentialsSafe } from '@wix/premium-fed-sdk/@premium-essentials';
import { DomainsApiClient } from '@wix/domains-serverless-interface/react-kit';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
import { ExperimentSpecs } from '../../constants';
import { BaseVoucherBanner } from './VoucherBanner';
export const AccountVoucherBanner = () => {
  var _getPremiumEssentials;
  const {
    t,
    Trans
  } = DomainSearchGateModule.internals.useTranslations();
  const {
    data,
    isLoading
  } = DomainsApiClient.hooks.useDomainsAccount({});
  const isMatchCycle = !!((_getPremiumEssentials = getPremiumEssentialsSafe()) != null && (_getPremiumEssentials = _getPremiumEssentials.experiments) != null && _getPremiumEssentials[ExperimentSpecs.MatchDomainCycleToPremiumCycle]);
  if (isLoading) {
    return null;
  }
  if (data != null && data.hasValidVouchers) {
    var _data$voucherSupporte;
    return /*#__PURE__*/React.createElement(BaseVoucherBanner, {
      icon: /*#__PURE__*/React.createElement(Gift, null),
      content: /*#__PURE__*/React.createElement(Trans, {
        i18nKey: isMatchCycle ? 'domain_search_gate.voucher_banner.match_cycle' : 'domain_search_gate.voucher_banner',
        components: [/*#__PURE__*/React.createElement("b", null)]
      }),
      tooltip: /*#__PURE__*/React.createElement(Box, {
        direction: "vertical",
        gap: "SP3",
        width: "100%",
        padding: "SP3 SP4"
      }, /*#__PURE__*/React.createElement(Text, {
        size: "small",
        weight: "thin",
        light: true
      }, t('domain_search_gate.voucher_banner.tld_tooltip')), /*#__PURE__*/React.createElement(Layout, {
        justifyItems: "fit-content",
        gap: "0",
        cols: 5
      }, data == null || (_data$voucherSupporte = data.voucherSupportedTlds) == null ? void 0 : _data$voucherSupporte.map(tld => /*#__PURE__*/React.createElement(Cell, {
        key: tld,
        span: 2.4
      }, /*#__PURE__*/React.createElement(Text, {
        size: "tiny",
        weight: "thin",
        light: true
      }, `.${tld}`)))))
    });
  }
  return /*#__PURE__*/React.createElement(BaseVoucherBanner, {
    icon: /*#__PURE__*/React.createElement(Gift, null),
    content: t(isMatchCycle ? 'domain_search_gate.domain_gate.header.match_cycle' : 'domain_search_gate.domain_gate.header.one_year_free')
  });
};
//# sourceMappingURL=AccountVoucherBanner.js.map